import { PwnType } from '../shared/enums/pwn-type';
import { IPwnStructure } from './pwn-structure';

export interface IPwnInfo {
  title: string;
  route: string;
  pwnType: PwnType;
  structure: IPwnStructure;
}

export const PWN_INFO: Record<string, IPwnInfo> = {
  preSchool: {
    pwnType: PwnType.PreSchool,
    title: 'Preschool',
    route: 'preschool',
    structure: {
      introduction: {
        purposeOfNoticeDoe: true,
        subjectOfNotice: 'Referral for an Initial Evaluation',
        descriptionOfAction: true,
        explanationOfAction: true,
      },
      additionalAssessments: {
        requireAdditionalAssessments: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Indicate other option(s) considered prior to the determination to conduct this evaluation: *',
        otherFactors:
          'Indicate other factor(s) relevant to the decision to conduct this evaluation: *',
        indicateOptionsConsidered: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      sources: {
        sources: true,
      },
    },
  },

  proposedRequestReevaluation: {
    pwnType: PwnType.RequestForReEval,
    title: 'Proposed Request for Reevaluation',
    route: 'proposed-request-reevaluation',
    structure: {
      introduction: {
        subjectOfNotice: 'Reevaluation',
        purposeOfNoticeDistrict: true,
        explanationOfAction: true,
        hidForParentallyPlaced: true,
      },
      additionalAssessments: {
        requireAdditionalAssessments: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Indicate other option(s) considered prior to the determination to not conduct this Reevaluation: *',
        otherFactors:
          'Indicate other factor(s) relevant to the decision to conduct a reevaluation: *',
        indicateOptionsConsidered: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
      contacts: {
        staffContact: true,
        additionalAssessmentsContact: true,
      },
      sources: {
        sources: true,
      },
    },
  },
  noticeOfIr: {
    pwnType: PwnType.NoticeOfIR,
    title: 'Notice Of Initial Referral',
    route: 'notice-of-ir',
    structure: {
      introduction: {
        subjectOfNotice: 'Referral for an Initial Evaluation',
        referrer: true,
        descriptionOfAction: true,
        purposeOfNoticeDistrict: true,
        explanationOfAction: true,
        descriptionOfNYSCPS: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
      evaluationDescription: {
        addDecisionReason: true,
        reasonDescription: false,
        reasonDescriptionDate: true,
      },
      otherOptions: {
        otherOptions:
          'Indicate other option(s) considered prior to the determination to  conduct this evaluation: *',
        otherFactorsToNotConduct:
          'Indicate other factors relevant to the decision to conduct this evaluation: *',
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },

      additionalAssessments: {
        requireAdditionalAssessments: true,
      },
    },
  },

  refusal: {
    pwnType: PwnType.Refusal,
    title: 'Refusal',
    route: 'refusal',
    structure: {
      introduction: {
        purposeOfNoticeDoe: true,
        subjectOfNotice: 'Refusal of Request to Conduct Initial Evaluation',
        descriptionOfAction: true,
        explanationOfAction: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptionsToNotConduct:
          'Indicate other option(s) considered prior to the determination not to conduct this evaluation: *',
        otherFactorsToNotConduct:
          'Indicate other factor(s) relevant to the decision not to conduct this evaluation: *',
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      sources: {
        sources: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
    },
  },

  requestForAdditionalReevaluation: {
    pwnType: PwnType.AdditionalReEval,
    title: 'Request for Additional Reevaluation',
    route: 'request-additional-reevaluation',
    structure: {
      introduction: {
        subjectOfNotice: 'Additional Reevaluation',
        purposeOfNoticeDistrict: true,
        explanationOfAction: true,
        hidForParentallyPlaced: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      additionalAssessments: {
        requireAdditionalAssessments: true,
      },
      otherOptions: {
        otherOptions:
          'Indicate other option(s) considered prior to the determination to not conduct this Additional Reevaluation: *',
        otherFactors:
          'Indicate other factors relevant to the decision to not conduct this Additional Reevaluation: *',
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
        additionalAssessmentsContact: true,
      },
      sources: {
        sources: true,
      },
    },
  },
  refusalOfRequestForReevaluation: {
    pwnType: PwnType.RefusalReEval,
    title: 'Refusal of Request for Reevaluation',
    route: 'refusal-request-reevaluation',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        subjectOfNotice:
          'Refusal to Conduct Reevaluation Requested by a Third Party',
        explanationOfAction: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Indicate other option(s) considered prior to the determination to not conduct this Reevaluation: *',
        otherFactors:
          'Indicate other factors relevant to the decision to not conduct a reevaluation: *',
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
    },
  },
  refusalOfRequestForAdditionalReevaluation: {
    pwnType: PwnType.RefusalAdditionalReEval,
    title: 'Refusal of Request for Additional Reevaluation',
    route: 'refusal-request-additional-reevaluation',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        subjectOfNotice: 'Refusal to Conduct Additional Reevaluation',
        descriptionOfAction: true,
        explanationOfAction: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        iepMaterials: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Indicate other option(s) considered prior to the determination to not conduct this Additional Reevaluation: *',
        otherFactors:
          'Indicate other factors relevant to the decision to not conduct an additional reevaluation: *',
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
    },
  },
  mandatedThreeYearReevaluation: {
    pwnType: PwnType.Mandated3YearReEval,
    title: 'Mandated Three-Year Reevaluation',
    route: 'three-year-reevaluation',
    structure: {
      introduction: {
        subjectOfNotice: 'Mandated Three Year Reevaluation',
        purposeOfNoticeDoe: true,
        descriptionOfAction: true,
        explanationOfAction: true,
        hidForParentallyPlaced: true,
      },
      additionalAssessments: {
        requireAdditionalAssessments: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      sources: {
        sources: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
    },
  },
  parentWaiverMandatedThreeYearReevaluation: {
    pwnType: PwnType.ParentWaiverMandated3YearReEval,
    title: 'Parent Waiver of Mandated Three-Year Reevaluation',
    route: 'parent-waiver-three-year-reevaluation',
    structure: {
      introduction: {
        purposeOfNoticeParentWaiverMandatedThreeYearReevaluation: true,
        hidForParentallyPlaced: true,
        showForParentWaiverMandatedThreeYearReevaluation: true,
        //subjectOfNotice: 'Referral for an Initial Evaluation',
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      // sources: {
      //   sources: true,
      // },
    },
  },
  parentRequestAdditionalAssessments: {
    pwnType: PwnType.RequestAdditionalAssessments,
    title: 'Request for Additional Assessments',
    route: 'request-additional-assessments',
    structure: {
      introduction: {
        purposeOfNoticeDoe: true,
        subjectOfNotice: 'Request for Additional Assessment(s)',
      },
      assessmentsRequested: {
        assessmentTypePurposeStatus: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
    },
  },
  parentallyPlaced: {
    pwnType: PwnType.ParentallyPlaced,
    title: 'Parentally Placed',
    route: 'parentally-placed',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        hidForParentallyPlaced: false,
        subjectOfNotice: 'Initial',
        descriptionOfAction: true,
        recommendation: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherFactors:
          'Description of other factors that are relevant to the proposed or refused action',
        otherOptions: 'Reason(s) why options rejected',
      },
      contacts: {
        staffContact: true,
        assistanceContact: true,
      },
      sources: {
        sources: true,
      },
      additionalInformation: {
        additionalInformation: true,
      },
    },
  },
  withdrawalInitialReferralFromSpecialEducationProcess: {
    pwnType: PwnType.WithdrawalInitialReferralFromSpecialEducationProcess,
    title: 'Withdrawal of Initial Referral from Special Education Process',
    route: 'withdrawal-initial-referral-special-education-process',
    structure: {
      introduction: {
        hidForParentallyPlaced: true,
        withdrawalInitialReferral: true,
        subjectOfNotice:
          'Withdrawal of Initial Referral from Special Education Process',
        descriptionOfAction: true,
        explanationOfAction: true,
      },
      otherOptions: {
        otherFactors:
          'Indicate other factors relevant to the decision to conduct this evaluation: *',
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      // additionalInformation: {
      //     additionalInformation: true
      // }
    },
  },

  initial: {
    pwnType: PwnType.Initial,
    title: 'Initial',
    route: 'initial',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        subjectOfNotice: 'Initial',
        descriptionOfAction: true,
        explanationOfAction: true,
        recommendation: true,
      },
      evaluationDescription: {
        iepMaterials: true,
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Any other options that were discussed and considered at the IEP meeting but not recommended should be explained here, along with the reasons they were not recommended. If a parent is seeking a particular testing accommodation or related service recommendation but the IEP team does not recommend that, the consideration of that accommodation or service and the reasons the IEP team did not recommend it must be specified here. *',
        otherFactors:
          'Indicate other factors relevant to the decision to conduct this evaluation: *',
        otherReasons:
          'Explain why the options considered are not appropriate for the student. This must be more than just indicating that a more or less restrictive setting is appropriate for the student.',
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      // additionalInformation: {
      //     additionalInformation: true,
      // }
    },
  },
  reevaluationAnnual: {
    pwnType: PwnType.ReevaluationAnnual,
    title: 'Reevaluation/Annual',
    route: 'reevaluation-annual',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        subjectOfNotice: 'Reevaluation/Annual',
        descriptionOfAction: true,
        recommendation: true,
        explanationOfAction: true,
        hidForParentallyPlaced: false,
      },
      evaluationDescription: {
        iepMaterials: true,
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Any other options that were discussed and considered at the IEP meeting but not recommended should be explained here, along with the reasons they were not recommended. If a parent is seeking a particular testing accommodation or related service recommendation but the IEP team does not recommend that, the consideration of that accommodation or service and the reasons the IEP team did not recommend it must be specified here. *',
        otherFactors:
          'Indicate other factors relevant to the decision to conduct this evaluation: *',
        otherReasons:
          'Explain why the options considered are not appropriate for the student. This must be more than just indicating that a more or less restrictive setting is appropriate for the student.',
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
      // additionalInformation: {
      //     additionalInformation: true
      // }
    },
  },

  declassification: {
    pwnType: PwnType.Declassification,
    title: 'Declassification',
    route: 'declassification',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        subjectOfNotice: 'Declassification',
        descriptionOfAction: true,
        explanationOfAction: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        iepMaterials: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Any other options that were discussed and considered at the IEP meeting but not recommended should be explained here, along with the reasons they were not recommended. If a parent is seeking a particular testing accommodation or related service recommendation but the IEP team does not recommend that, the consideration of that accommodation or service and the reasons the IEP team did not recommend it must be specified here. *',
        otherFactors:
          'Description of other factors that are relevant to the proposed or refused action *',
      },
      additionalInformation: {
        additionalInformation: true,
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
    },
  },
  initialEligibilityRecommendationIneligible: {
    pwnType: PwnType.InitialEligibilityRecommendationIneligible,
    title: 'Ineligible',
    route: 'initial-eligibility-recommendation-ineligible',
    structure: {
      introduction: {
        purposeOfNoticeDistrict: true,
        subjectOfNotice: 'Ineligible',
        descriptionOfAction: true,
        explanationOfAction: true,
      },
      evaluationDescription: {
        reasonDescriptionDate: true,
        addDecisionReason: true,
      },
      otherOptions: {
        otherOptions:
          'Any other options that were discussed and considered at the IEP meeting but not recommended should be explained here, along with the reasons they were not recommended. If a parent is seeking a particular testing accommodation or related service recommendation but the IEP team does not recommend that, the consideration of that accommodation or service and the reasons the IEP team did not recommend it must be specified here. *',
        otherFactors:
          'Description of other factors that are relevant to the proposed or refused action *',
      },
      additionalInformation: {
        additionalInformation: true,
      },
      sources: {
        sources: true,
      },
      contacts: {
        assistanceContact: true,
        staffContact: true,
      },
    },
  },
};
